import React from "react";
import "./YouTubePlayer.scss";

export interface YouTubePlayerProps {
  videoId: string;
  id?: string;
  title?: string;
  width?: number;
  height?: number;
}

export const YouTubePlayer: React.FC<YouTubePlayerProps> = ({
  videoId,
  id = "",
  title = "",
  width = "640px",
  height = "360px"
}) => {
  const urlParams = `autoplay=0&amp;mute=0&amp;controls=0&amp;origin=${window.location.origin}`;
  return (
    <div className="youtube-player" style={{ width: width, height: height }}>
      <iframe
        id={id}
        width="100%"
        height="100%"
        src={`https://www.youtube.com/embed/${videoId}?${urlParams}`}
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
        title={title}
      />
    </div>
  );
};
